<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="authors-note">
<h1>Author’s Note</h1>
<p>For those who do not toil in the fields of aviation, the terminology can be a bit confusing. “Effo”=FO=first officer, the pilot who is designated as second in command of the aeroplane and who occupies the seat on the right-hand side, next to the captain who occupies the seat on the left.</p>
<p>If you thought that the seating arrangements at a wedding were contentious and the cause of bitterness and discord, then you ain’t seen nothing yet.</p>
<p>The term FO also includes those who are designated as a senior first officer or SFO. These individuals have been judged to have sufficient experience and ability to have a command of their own and to bear the title “captain”, but due to lack of seniority or lack of command vacancies, still occupy the right-hand seat. They are identifiable by the three bars on their uniforms (junior FOs have two and captains wear four) and by the long-suffering, resigned look on their faces.</p>
<p>Rather like the religious concept of purgatory, this state of affairs has also been known to persist for eternity.</p>
<p>Confused? Then read on.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch006.vue?9e9aa0b6